
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/combat-terms",
      function () {
        return require("private-next-pages/combat-terms.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/combat-terms"])
      });
    }
  